<template>
  <v-container class="headermargin" v-if="pollManage !== undefined">
    <LoadingIcon v-if="pollManage === undefined" v-show="pollManage === undefined" />

    <!-- TOP PART OF THE CARD -->
    <v-card v-else-if="pollManage">
      <v-container class="painelpadding">
        <v-row>
          <v-col cols="11" xs="10">
            <v-card-title class="headergerencial">{{ pollManage.name }}</v-card-title>
            <v-card-subtitle class="notop nobottom">
              Link personalizado: <b>{{ pollManage.customLink }}</b>
              &nbsp;
              <v-tooltip bottom>
                <template v-slot:activator="{ on, copyIcon }">
                  <v-btn x-small text v-bind="copyIcon" v-on="on" @click="copyCustomUrl(pollManage.customLink)">
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>Copiar</span>
              </v-tooltip>
            </v-card-subtitle>
          </v-col>

          <v-col cols="1" xs="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, editBtn }">
                <a v-bind="editBtn" v-on="on" @click="editPoll()" class="editartext">
                  Editar <i class="material-icons">edit</i>
                </a>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <v-divider></v-divider> <!-- END OF TOP PART OF THE CARD -->

        <v-tabs v-model="currentTab" background-color="transparent" color="primary">
          <v-tab v-for="item in tabs" :key="item.name">
            {{ (item && item.name) ? item.name : '' }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="currentTab">
          <v-tab-item v-for="item in tabs" :key="item.name">
            <v-card flat>
              <component :is="item.component"></component>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </v-card>

    <v-card v-else-if="pollManage === null">
      <v-container class="nonothing">
        <v-card-title>Votação não foi encontrada ou ainda é um rascunho</v-card-title>
      </v-container>
    </v-card>
  </v-container>
</template>


<script>
  import LoadingIcon from '@/components/utils/LoadingIcon';
  import PollManageData from '@/components/poll/manage/Data';
  import PollManageProject from '@/components/poll/manage/Project';
  import PollManageStats from '@/components/poll/manage/Stats';

  import {
    mapState,
    mapActions
  } from "vuex";

  export default {
    name: 'PollManage',
    components: {
      LoadingIcon,
      PollManageData,
      PollManageProject,
      PollManageStats
    },
    computed: {
      ...mapState(["pollManage"]),
    },
    beforeMount() {
      const pollId = this.$route.params.id;
      this.$store.dispatch('getPollManage', {
        pollId
      });
    },
    data: () => ({
      currentTab: null,
      tabs: [{
        name: 'Dados',
        component: PollManageData,
      }, {
        name: 'Projetos',
        component: PollManageProject,
      }, ]
    }),
    methods: {
      ...mapActions(['getPollManage']),
      copyLink() {
        this.$router.push({
          name: 'PollEdit',
          params: {
            id: this.id
          }
        });
      },
      editPoll() {
        this.$router.push({
          name: 'PollEdit',
          // params: {id: this.$route.params.id}
        });
      },
      configPoll() {
        this.$router.push({
          name: 'PollEdit',
          params: {
            id: this.$route.params.id
          }
        });
      },
      copyCustomUrl(url) {
        navigator.clipboard.writeText('https://' + url + '.prosas.com.br');
      }
    },
  };
</script>

<style scoped>
  .headermargin {
    padding: 48px 0 !important;
  }

  .painelpadding {
    padding: 16px;
  }

  @media screen and (min-width: 1440px) {
    #main-container {
        max-width: 1440px !important;
        padding: 0;
    }
  }

  @media (max-width: 1440px) {
    #main-container {
        max-width: 1280px !important;
    }
  }

  .container {
    max-width: 100%;
  }

  .titledados {
    color: #415b64;
    margin: 24px 0 4px;
    letter-spacing: 0;
    opacity: 1;
    font-weight: 400;
    font-size: 24px;
  }

  .headergerencial {
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 0.2px;
    color: #242424;
    opacity: 0.7;
    margin: 0 0 12px;
    line-height: 26px;
    padding: 0 16px;
  }

  .editartext {
    color: #20c09e;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Source Sans Pro', sans-serif;
  }

  .material-icons {
    font-size: 24px;
    line-height: 24px;
    float: left;
    padding: 0 6px 0 0;
  }

  .v-tabs-bar__content {
    border-bottom: thin solid #e0e0e0;
  }
</style>


// WEBPACK FOOTER //
// src/pages/poll/PollManage.vue